import * as React from "react";
import { Select, SelectProps } from "@mui/base/Select";
import { SelectOption } from "@mui/base/useOption";
import { Option } from "@mui/base/Option";

// Styles
import "./SelectCountries.scss";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface SelectionProps {
  options: any;
  placeholder?: string;
  register?: any;
  errors?: any;
}
const CustomSelect = React.forwardRef<
  HTMLButtonElement,
  SelectProps<number, false>
>((props, ref) => {
  const slots: SelectProps<number, false>["slots"] = { ...props.slots };
  const { t } = useTranslation();
  return (
    <Select
      {...props}
      slots={slots}
      ref={ref}
      aria-label={t("contact.form.country") || ""}
    />
  );
});

const SelectCountries: React.FC<SelectionProps> = ({
  options,
  placeholder,
  register,
  errors,
}) => {
  const { setValue } = useFormContext();

  function renderValue(option: SelectOption<number> | null) {
    if (option == null) {
      return <p>{placeholder}</p>;
    }
    return <p>{option.value}</p>;
  }
  return (
    <CustomSelect
      id="country"
      className={
        errors.country
          ? "input invalid input-focus select-countries"
          : "input input-focus select-countries valid"
      }
      renderValue={renderValue}
      listboxId="list-countries"
      {...register("country", { required: true })}
    >
      {options.map((option: any, index: number) => {
        return (
          <Option
            className="option-dropdown"
            key={index}
            value={option}
            onClick={() => {
              setValue("country", option, {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true,
              });
            }}
          >
            {" "}
            {option}{" "}
          </Option>
        );
      })}
    </CustomSelect>
  );
};

export default SelectCountries;
